const BYTES_IN_MB = 1024 * 1024;

// Per-file limit of attachments and documents; the backend takes the same 20 MB
export const MAX_FILE_SIZE = 20 * BYTES_IN_MB;

export const formatMaxSizeHint = (maxSize: number) =>
  `Maximum File Size is ${maxSize / BYTES_IN_MB}MB`;

export const MAX_FILE_SIZE_HINT = formatMaxSizeHint(MAX_FILE_SIZE);
